// extracted by mini-css-extract-plugin
module.exports = {"StarBox":"RatingStars_StarBox__8egsG","Star":"RatingStars_Star__1c1Ub","red":"RatingStars_red__2tn8_","yellow":"RatingStars_yellow__2vNY6"};